<template>
  <div class="chat-conversations" id="conversationContainer">
    <div class="chat-conversations-header">
      <ConversationsSearch v-model="searchText" />
    </div>

    <ConversationsLoading v-if="isLoading" />

    <div class="chat-conversations-list">
      <div v-for="conversation in filteredConversations" :key="conversation.conversationId"
      class="chat-conversations-list-item"
        if="conversation.conversationId === selectedConversationId"
        :class="{ 'chat-conversation-selected': conversation.conversationId === selectedConversationId }"
        @click="handleConversationClick(conversation)"
        >
        <div class="chat-conversations-list-item-avatar">
          <img :src="getAvatar(conversation.photo)" alt="avatar" />
        </div>
        <div class="chat-conversations-list-item-info">
          <div class="chat-conversations-list-item-info-conversationid">
            {{ conversation.protocol }}
          </div>
          <div class="chat-conversations-list-item-info-name">
            <div :title="getDisplayName(conversation)">{{ getDisplayName(conversation) }}</div>
          </div>
          <div class="chat-conversations-list-item-info-message">
            {{ conversation.lastMessageType == 'chat'
              ? conversation.lastMessage.text
              : conversation.lastMessage.type == 'image'
                ? 'Imagem'
                : conversation.lastMessage.type == 'ptt'
                  ? 'Áudio'
                  : conversation.lastMessage.type == 'list'
                    ? 'Lista'
                    : conversation.lastMessage.type == 'document'
                      ? 'Documento' : ''
            }}
          </div>
        </div>
        <div class="chat-conversations-list-item-identify">
          <div class="chat-conversations-list-item-identify-provider">
          <img :src="`static/img/chat/providers/${conversation.provider}.png`" width="15px" alt="provider" />
        </div>
        <div class="chat-conversations-list-item-identify-countNotReads" v-if="conversation.unreaded > 0">
          {{ conversation.unreaded }}
        </div>
        </div>
      </div>
    </div>
    <!-- <div class="createNewConversation">
      <span @click="openAttachModalNewConversation">
        <i class="fa fa-plus" aria-hidden="true"></i> Iniciar nova conversa
      </span>
    </div> -->
    <b-modal centered ref="modal-new" v-model="showModalNewConversation" title="Criar Conversa">
      <div>
        <b-form-group label="Associado" label-for="conversation-person">
          <b-form-input id="conversation-person" v-model="newConversationPerson"></b-form-input>
        </b-form-group>
        <b-form-group label="Telefone" label-for="conversation-subject">
          <b-form-input id="conversation-subject" v-model="newConversationSubject" required></b-form-input>
        </b-form-group>
        <b-form-group label="Mensagem" label-for="conversation-subject">
          <b-form-textarea id="conversation-subject" v-model="newConversationMessage" required></b-form-textarea>
        </b-form-group>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="getNewConversation" v-b-tooltip.hover
            :title="'Criar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none">Criar</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ConversationsLoading from './ConversationsLoading.vue'
import ConversationsSearch from './ConversationsSearch.vue'
import ConversationsTabs from './ConversationsTabs.vue'

export default {
  name: 'Messages',
  components: {
    ConversationsSearch,
    ConversationsLoading,
    ConversationsTabs
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    conversations: {
      type: Array,
      required: true
    },
    selectedConversationId: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      tabs: {
        active: 'Aberto',
        items: [
          {
            value: 'Aberto'
          },
          {
            value: 'Finalizado'
          }
        ]
      },
      searchText: '',
      timer: null,
      showModalNewConversation: false,
      newConversationMessage: '',
      newConversationSubject: '',
      newConversationPerson: '',
      paramConversationId: ''
    }
  },
  computed: {
    filteredConversations () {
      return this.conversations.filter(conversation => {
        return conversation.botId === 'NDA' && (conversation.name.nome.toLowerCase().includes(this.searchText.toLowerCase()) || conversation.conversationId.toString().toLowerCase().includes(this.searchText.toLowerCase()) || conversation.identifier.toString().toLowerCase().includes(this.searchText.toLowerCase().replace(/\D/g, '')) || conversation.protocol.toString().toLowerCase().includes(this.searchText.toLowerCase().replace(/\D/g, '')))
      })
    }
  },
  mounted () {
  },
  watch: {
    'tabs.active' (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('changeTab', newValue)
      }
    },
    filteredConversations: {
      handler () {
        const url = window.location.href

        const urlParams = new URLSearchParams(new URL(url).search)
        if (this.selectedConversationId === null && urlParams.get('conversationId') !== null) {
          const conversationId = urlParams.get('conversationId')
          const conversation = this.filteredConversations.find(c => c.conversationId === conversationId)
          if (conversation && this.selectedConversationId !== conversationId) {
            this.handleConversationClick(conversation)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    handleConversationClick (conversation) {
      this.$router.push({ query: { conversationId: conversation.conversationId } })
      this.$emit('selectConversation', conversation)
    },
    getDisplayName (conversation) {
      let name = 'Usuário não possui nome'
      if (conversation.name.nome) {
        name = conversation.name.nome
      }
      return name
    },
    getOrigemDisplayName (conversation) {
      let origem = conversation.name.origem
      if (origem === 'Conversa') {
        return 'Esse nome é de uma conversa'
      } else if (origem === 'Campanha') {
        return 'Esse nome é de uma campanha'
      } else if (origem === 'Pessoa') {
        return 'Esse nome é de um associado'
      } else {
        return 'Nome não registrado'
      }
    },
    openAttachModalNewConversation () {
      this.showModalNewConversation = true
    },
    getNewConversation () {
      const conversationDTO = {
        identifier: this.newConversationSubject,
        status: 'A',
        message: {
          message: this.newConversationMessage,
          type: 'text'
        },
        operatorId: null,
        provider: 'whats_wpp'
      }
      this.$emit('createNewConversation', conversationDTO)
    },
    createNewConversation () {
      console.log('createNewConversation')
    },
    getAvatar (encodedImage) {
      if (encodedImage) {
        return `data:image/png;base64,${encodedImage}`
      }

      return '/static/img/avatars/03.png'
    }
  }
}
</script>
<style lang="scss">
#conversationContainer{

  .createNewConversation {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .createNewConversation span:hover {
    color: #04a791;
  }

  /* .createNewConversation {
    position: flex;
    bottom: 20px;
    right: 20px;
    background-color: #04a791;
    color: white;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
    margin-top: 10px;
  };

  .createNewConversation i {
    color: white;
  }
  .createNewConversation a {
    color: white;
  }
  .createNewConversation a:hover {
    color: white;
  } */
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/conversations/Conversations.vue